import React from "react";
import { TenantUsersList } from "./TenantUsersList";
import { Paginator } from "../../../../../components/Table/Paginator";
import ControlledQuickSearch from "../../../../../components/QuickSearch/ControlledQuickSearch";

import type { TenantUser } from "../../shared/types/models";
import type { Paginated } from "../../../../../apis/types";

export interface TenantUsersViewProps {
  tenantUsers?: Paginated<TenantUser>;
  isLoadingTenantUsers: boolean;
  navigateToTenantDetails: (tenantUser: TenantUser) => void;
  handlePaginatorClick: (page: number) => void;
  searchTerm: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const TenantUsersView: React.FC<TenantUsersViewProps> = (props) => {
  function handleTenantUserRowClick(tenantUser: TenantUser): void {
    props.navigateToTenantDetails(tenantUser);
  }

  return (
    <div className="max-w-7xl mx-auto px-4">
      <main className="max-w-5xl mx-auto py-6">
        <div className="flex justify-between items-center">
          <span className="font-semibold text-xl text-gray-700 dark:text-gray-200">Tenant Users</span>
        </div>
        <div className="mt-4 mb-4">
          <div className="max-w-md">
            <ControlledQuickSearch
              title="Search Tenant Users"
              handleChange={props.onSearchChange}
              placeholder="Search by email or account name..."
              value={props.searchTerm}
            />
          </div>
        </div>
        <div className="mt-3">
          <TenantUsersList
            tenantUsers={props.isLoadingTenantUsers ? [] : props.tenantUsers?.results ?? []}
            handleRowClick={handleTenantUserRowClick}
            searchTerm={props.searchTerm}
          />
          {props.tenantUsers && !props.isLoadingTenantUsers && (
            <Paginator 
              data={{
                total: props.tenantUsers.total,
                resultsPerPage: props.tenantUsers.resultsPerPage,
                page: props.tenantUsers.page
              }}
              handlePaginatorClick={props.handlePaginatorClick}
              className="mt-4"
            />
          )}
        </div>
      </main>
    </div>
  );
};